/**
 *  ResultsScene
 *
 *  Created by Legman on 27/03/2016.
 *
 */

import AudioParams from "../AudioParams";
import Common from "../Common";

/**
 * @class
 */
export default class ResultsScene extends p3.Scene {
    /**
     * @param {number} [id]
     * @param {number} [place]
     */
    constructor(id, place) {
        super();

        /**
         * @type {number}
         * @private
         */
        this._id = id || 0;

        /**
         * @type {number}
         * @private
         */
        this._place = place || 0;

        /**
         * @member {p3.Button}
         * @private
         */
        this._nextButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        this._replayButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._muteButton = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._shine1 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._shine2 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._sign = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._badge = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._trophy = null;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        this._emitter = null;

        /**
         * @type {Audio}
         * @private
         */
        this._outroSFX = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(Common.blankTexture);
        bg.width = Common.STAGE_WIDTH;
        bg.height = Common.STAGE_HEIGHT;
        this.addChild(bg);

        this._shine2 = new PIXI.Sprite(assets.getTexture("ui_result_shine_2"));
        this._shine2.x = Common.STAGE_WIDTH * 0.5 - 220;
        this._shine2.y = Common.STAGE_HEIGHT * 0.5 - 120;
        this._shine2.scale = new PIXI.Point(4, 4);
        this._shine2.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._shine2);

        this._shine1 = new PIXI.Sprite(assets.getTexture("ui_result_shine_1"));
        this._shine1.x = Common.STAGE_WIDTH * 0.5 - 220;
        this._shine1.y = Common.STAGE_HEIGHT * 0.5 - 120;
        this._shine1.scale = new PIXI.Point(4, 4);
        this._shine1.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._shine1);

        this._badge = new PIXI.Sprite(assets.getTexture("ui_result_position_bg"));
        this._badge.x = Common.STAGE_WIDTH * 0.5 - 200;
        this._badge.y = Common.STAGE_HEIGHT * 0.5 - 140;
        this._badge.anchor = new PIXI.Point(0.5, 0.5);
        this._badge.visible = false;
        this.addChild(this._badge);

        const config = assets.getJSON("particle_emitter_trophy_stars_00");
        let holder = new PIXI.Container();
        holder.x = 8;
        holder.y = -12;
        this._badge.addChild(holder);

        this._emitter = new PIXI.particles.Emitter(holder, [
            assets.getTexture("particle_impact_star_orange"),
            assets.getTexture("particle_impact_star_white"),
            assets.getTexture("particle_impact_star_yellow")
        ], config);

        this._trophy = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._trophy.x = -8;
        this._trophy.y = 50;
        this._trophy.anchor = new PIXI.Point(0.5, 0.5);
        this._badge.addChild(this._trophy);

        const footer = new PIXI.Sprite(assets.getTexture("ui_result_bg_bottom"));
        footer.x = (Common.STAGE_WIDTH - footer.width) * 0.5;
        footer.y = Common.STAGE_HEIGHT - footer.height;
        this.addChild(footer);

        this._sign = new PIXI.Sprite(assets.getTexture("ui_info_sign"));
        this._sign.y = p3.View.height - 80;
        this._sign.anchor = new PIXI.Point(0.5, 0.5);
        this._sign.visible = false;
        this.addChild(this._sign);

        let str, strings;
        if (this._place <= 2) {
            strings = ["results_sign_amazing", "results_sign_brilliant", "results_sign_fantastic"];
        } else {
            strings = ["results_sign_nice_try", "results_sign_keep_trying"];
        }
        str = strings[Math.floor(Math.random() * strings.length)];

        if (language === "ar") {
            this._sign.label = new PIXI.Text(translate(str), {
                fontSize: "36px", fontFamily: "Noto Kufi Arabic", fill: 0x450C41, align: "center", padding: 6});
            this._sign.label.x = 8;
            this._sign.label.y = -130;
            this._sign.label.rotation = -0.024;
            this._sign.label.pivot.x = this._sign.label.width * 0.5;
            this._sign.label.pivot.y = this._sign.label.height * 0.5;
            this._sign.addChild(this._sign.label);
        } else {
            this._sign.label = new PIXI.BitmapText(translate(str), font(40, "center"));
            this._sign.label.x = 8;
            this._sign.label.y = -130;
            this._sign.label.rotation = -0.024;
            this._sign.label.pivot.x = this._sign.label.textWidth * 0.5;
            this._sign.label.pivot.y = this._sign.label.textHeight * 0.5;
            this._sign.label.tint = 0x450C41;
            this._sign.addChild(this._sign.label);
        }

        const character = Common.config.characters[this._id];

        holder = new PIXI.Container();
        holder.y = p3.View.height;
        this.addChild(holder);

        this._sidekick = new PIXI.Sprite(character.sidekick ? assets.getTexture(character.sidekick.texture) : PIXI.Texture.EMPTY);
        this._sidekick.x = character.sidekick ? character.sidekick.offset.x : 0;
        this._sidekick.y = character.sidekick ? character.sidekick.offset.y : 0;
        this._sidekick.anchor = new PIXI.Point(0.5, 1);
        this._sidekick.visible = false;
        holder.addChild(this._sidekick);

        this._driver = new PIXI.Sprite(assets.getTexture(character.driver.texture));
        this._driver.x = character.driver.offset.x;
        this._driver.y = character.driver.offset.y;
        this._driver.anchor = new PIXI.Point(0.5, 1);
        this._driver.visible = false;
        holder.addChild(this._driver);

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_play");

        this._nextButton = new p3.Button(states);
        this._nextButton.visible = false;
        this._nextButton.interactive = false;
        this._nextButton.overSoundName = "sfx_btn_rollover_00";
        this._nextButton.clickSoundName = "sfx_btn_press_00";
        this._nextButton.signals.click.add(this.onNextButtonClick, this);
        this.addChild(this._nextButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_replay");

        this._replayButton = new p3.Button(states);
        this._replayButton.visible = false;
        this._replayButton.interactive = false;
        this._replayButton.overSoundName = "sfx_btn_rollover_00";
        this._replayButton.clickSoundName = "sfx_btn_press_00";
        this._replayButton.signals.click.add(this.onReplayButtonClick, this);
        this.addChild(this._replayButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_home");

        this._homeButton = new p3.Button(states);
        this._homeButton.visible = false;
        this._homeButton.interactive = false;
        this._homeButton.overSoundName = "sfx_btn_rollover_00";
        this._homeButton.clickSoundName = "sfx_btn_press_00";
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this.addChild(this._homeButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_sound_on");
        states.iconAlt = assets.getTexture("ui_icon_sound_off");

        this._muteButton = new p3.MuteButton(states);
        this._muteButton.visible = false;
        this._muteButton.interactive = false;
        this._muteButton.overSoundName = "sfx_btn_rollover_00";
        this._muteButton.clickSoundName = "sfx_btn_press_00";
        this.addChild(this._muteButton);

        if (this._place > 2) {
            bg.tint = 0xB3B5DC;
            this._shine1.tint = 0xFFFFFF;
            this._shine2.tint = 0x83EFFF;
            if (this._place === 3) {
                this._trophy.texture = assets.getTexture("ui_result_position_4");
            } else if (this._place === 4) {
                this._trophy.texture = assets.getTexture("ui_result_position_5");
            }
        } else if (this._place === 2) {
            bg.tint = 0xF47970;
            this._shine1.tint = 0xFFFFFF;
            this._shine2.tint = 0xEB8622;
            this._trophy.texture = assets.getTexture("ui_result_position_3");
        } else if (this._place === 1) {
            bg.tint = 0x8D82CD;
            this._shine1.tint = 0xFFFFFF;
            this._shine2.tint = 0xFE588E;
            this._trophy.texture = assets.getTexture("ui_result_position_2");
        } else if (this._place === 0) {
            bg.tint = 0xC5639A;
            this._shine1.tint = 0xFFEB62;
            this._shine2.tint = 0xFFE383;
            this._trophy.texture = assets.getTexture("ui_result_position_1");
        }
    }

    destroy(destroyChildren) {
        this._emitter.destroy();

        super.destroy(destroyChildren);
    }

    appear() {
        super.appear();

        Common.audio.playSound("sfx_crowd_cheer_00");
        if (this._place <= 2) {
            Common.audio.playSound("sfx_fanfare_00");
        }

        const params = new AudioParams();
        params.callback = function() {
            Common.audio.playMusic("music_garage_loop_00");
        };
        params.scope = this;

        Common.audio.stopMusic();
        this._outroSFX = Common.audio.playSound("music_race_end_00", params);
    }

    show() {
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        this._homeButton.scale = new PIXI.Point();
        TweenMax.to(this._homeButton.scale, 0.4, {
            delay: 0.1,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._homeButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._homeButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._muteButton.scale = new PIXI.Point();
        TweenMax.to(this._muteButton.scale, 0.4, {
            delay: 0.1 + 0.06,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._muteButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._muteButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._replayButton.scale = new PIXI.Point();
        TweenMax.to(this._replayButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 3,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._replayButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._replayButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._nextButton.scale = new PIXI.Point();
        TweenMax.to(this._nextButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 4,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._nextButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._nextButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._badge.scale = new PIXI.Point();
        TweenMax.killTweensOf(this._badge.scale);
        TweenMax.to(this._badge.scale, 0.34, {
            delay: 0.04,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                this._badge.visible = true;
            },
            onStartScope: this
        });

        this._trophy.scale = new PIXI.Point();
        TweenMax.killTweensOf(this._trophy.scale);
        TweenMax.to(this._trophy.scale, 0.34, {
            delay: 0.2,
            x: 1,
            ease: Back.easeOut,
            easeParams: [1]
        });
        TweenMax.to(this._trophy.scale, 0.26, {
            delay: 0.2,
            y: 1,
            ease: Back.easeOut,
            easeParams: [3]
        });

        let to = this._sign.y;
        this._sign.y = this._sign.y + 400;
        TweenMax.killTweensOf(this._sign);
        TweenMax.to(this._sign, 0.32, {
            delay: 0.52,
            y: to,
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                this._sign.visible = true;
            },
            onStartScope: this
        });

        // slide driver
        to = this._driver.x;
        this._driver.x = this._driver.x + 800;
        TweenMax.killTweensOf(this._driver);
        TweenMax.to(this._driver, 0.4, {
            delay: 0.3,
            x: to,
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                this._driver.visible = true;
            },
            onStartScope: this
        });

        // fade driver
        this._driver.alpha = 0;
        TweenMax.to(this._driver, 0.2, {
            delay: 0.3,
            alpha: 1,
            ease: Power1.easeInOut
        });

        // bounce driver
        this._driver.rotation = 0.14;
        TweenMax.to(this._driver, 0.8, {
            delay: 0.46,
            rotation: 0,
            ease: Elastic.easeOut,
            easeParams: [1]
        });

        // slide sidekick
        to = this._sidekick.x;
        this._sidekick.x = this._sidekick.x + 800;
        TweenMax.killTweensOf(this._sidekick);
        TweenMax.to(this._sidekick, 0.4, {
            delay: 0.5,
            x: to,
            ease: Back.easeOut,
            easeParams: [1],
            onStart: function() {
                this._sidekick.visible = true;
            },
            onStartScope: this
        });

        // fade sidekick
        this._sidekick.alpha = 0;
        TweenMax.to(this._sidekick, 0.2, {
            delay: 0.5,
            alpha: 1,
            ease: Power1.easeInOut
        });

        // bounce sidekick
        this._sidekick.rotation = 0.14;
        TweenMax.to(this._sidekick, 0.8, {
            delay: 0.66,
            rotation: 0,
            ease: Elastic.easeOut,
            easeParams: [1]
        });
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;

        this._driver.parent.x = Common.STAGE_WIDTH * 0.5 + p3.View.width * 0.24;

        this._sign.x = Common.STAGE_WIDTH * 0.5 - p3.View.width * 0.176;

        this._nextButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 120;
        this._nextButton.y = p3.View.height - 120;

        this._replayButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 120;
        this._replayButton.y = p3.View.height - 120;

        this._homeButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
        this._homeButton.y = 100;

        this._muteButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._muteButton.y = 100;
    }

    update() {
        this._shine1.rotation += 0.12 * deltaTime;
        this._shine2.rotation -= 0.08 * deltaTime;

        this._emitter.update(deltaTime);
    }

    /**
     * @param {p3.Button} button
     */
    onNextButtonClick(button) {
        this.signals.next.dispatch(this);
    }

    /**
     * @param {p3.Button} button
     */
    onReplayButtonClick(button) {
        this.signals.previous.dispatch(this);
    }

    /**
     * @param {p3.Button} button
     */
    onHomeButtonClick(button) {
        this.signals.home.dispatch(this);
    }
}
